import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import type {ButtonProps} from '@tempo/core';
import {Button} from '@tempo/core';
import {useTracking} from '@app/modules/tracking';
import {useAuthLink} from '@app/hooks/use-link';

type HeaderLoginBtnProps = ButtonProps & {
	redirectUri?: string;
};

export const HeaderLoginBtn: FunctionComponent<HeaderLoginBtnProps> = ({
	redirectUri,
	...props
}) => {
	const {t} = useTranslation();
	const {getLoginLink} = useAuthLink();
	const {trackClick} = useTracking();
	return (
		<Button
			as="a"
			variant="outline"
			onClick={trackClick({
				eventaction: 'login-button',
				eventcategory: 'header',
			})}
			href={getLoginLink(redirectUri)}
			{...props}
		>
			{t('generic_action_login_standalone-features')}
		</Button>
	);
};

type HeaderRegisterBtnProps = ButtonProps & {
	redirectUri?: string;
};

export const HeaderRegisterBtn: FunctionComponent<HeaderRegisterBtnProps> = ({
	redirectUri,
	...props
}) => {
	const {t} = useTranslation();
	const {getRegistrationLink} = useAuthLink();
	const {trackClick} = useTracking();
	return (
		<Button
			as="a"
			onClick={trackClick({
				eventaction: 'register-button',
				eventcategory: 'header',
			})}
			href={getRegistrationLink(redirectUri)}
			{...props}
		>
			{t('generic_action_signup_standalone-features')}
		</Button>
	);
};
